module.exports = __webpack_public_path__ + "static/media/rodrigo.6a8efaca.jpg";